import { TTrackEventData, TTrackPageViewData } from '../../../tracking/constant';

export const ERROR_SCREEN_TRACKING_EVENTS = {
    ERROR_SCREEN_TRACKING: {
        component_name: 'event stream',
        component_type: 'alert',
        alert_action: 'view',
        alert_type: 'error',
        country: '',
        language: '',
        pageGroup: '',
        siteType: 'scoober - courier portal web',
        event:'alert_errorView'
    },
    ERROR_SCREEN_CTA_TRACKING:{
        component_name: 'event stream',
        component_type: 'alert',
        alert_action: 'select',
        alert_type: 'error',
        country: '',
        language: '',
        pageGroup: '',
        siteType: 'scoober - courier portal web',
        event:'alert_errorSelect'
    }
}

export type TErrorScreen = TTrackEventData<{ alert_action: string, alert_type: string, siteType: string }>;
export type TErrorScreenCTA = TTrackEventData<{ alert_action: string, alert_type: string, siteType: string }>;
export const ERROR_PAGE_TRACKING_EVENTS = {
    ERROR_PAGE_INITIALIZATION: {
        component_name: 'url',
        component_type: 'alert',
        alert_action: 'view',
        alert_type: 'error',
        country: '',
        language: '',
        pageGroup: 'error',
        siteType: 'scoober - courier portal web',
        event: 'alert_errorView'
    },
    ERROR_PAGE_CTA: {
        component_name: 'url',
        component_type: 'alert',
        alert_action:'select',
        alert_type: 'error',
        country: '',
        language: '',
        pageGroup:'error',
        siteType: 'scoober - courier portal web',
        event:'alert_errorSelect'
    }
}

export type TErrorPageInitialized = TTrackEventData<{ alert_action: string, alert_type: string, siteType: string }>;
export type TErrorPageCTA = TTrackEventData<{ alert_action: string, alert_type: string, siteType: string }>;

export const ERROR_PAGE_VIEW_EVENTS = {
    ERROR_PAGE_VIEW: {
        cookieConsent: '',
        country: '',
        language: '',
        pageGroup: 'error',
        url: '',
        siteType: ''
    }
}

export type TErrorPageView = TTrackPageViewData<{ alert_action: string, alert_type: string, siteType: string }>;